import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import clock from "../../../assets/images/meetupEvent/clock.png";
import vector from "../../../assets/images/meetupEvent/Vector.png";

import axios from "axios";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import flag from "../../../assets/images/flag.png";
import flag4 from "../../../assets/images/Interval-01.1.png";
import flag2 from "../../../assets/images/Maximum-Time-01.1.png";
import flag3 from "../../../assets/images/Minimum-Time-01.1.png";
import flag1 from "../../../assets/images/Registration-End-01.1.png";
// import "./SuperStarContent.css";
import { Markup } from "interweave";
import moment from "moment";

import ReactPlayer from "react-player";
import { serverInfo } from "../../../App";
import { useContext } from "react";
import Countdown from "react-countdown";
import ContdownTimerRender from "../../../HelperComponent/ContdownTimerRender";
import AddBundleModal from "./AddBundleModal";
import swal from "sweetalert";

const QnADetails = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();

  const [event, setEvent] = useState("");
  const [slot, setSlot] = useState([]);
  const [availabilityStartTime, setAvailabilityStartTime] = useState([]);
  const [availabilityEndTime, setAvailabilityEndTime] = useState([]);
  const [bundles, setBundles] = useState([]);

  const event_id = props.match.params.id;
  useEffect(() => {
    let isMounted = true;

    axios.get(`/api/admin/qna/${event_id}`).then((res) => {
      if (isMounted) {
        if (res.data.status === 200) {
          setEvent(res?.data?.event);
          setBundles(res?.data?.event?.bundles);
          setAvailabilityStartTime(
            res?.data?.event?.star_availability_start_date
          );
          setAvailabilityEndTime(res?.data?.event?.star_availability_end_date);
        }
      }
    });
    axios.get(`/api/admin/registeredList/${event_id}`).then((res) => {
      if (res.data.status === 200) {
        setSlot(res.data.users);
      }
    });
  }, [props.match.params.slug, history]);

  const handleBundlesUpdate = (newBundle) => {
    setBundles((prevBundles) => {
      const existingBundleIndex = prevBundles.findIndex(
        (bundle) => bundle.id === newBundle.id
      );
      if (existingBundleIndex !== -1) {
        // Update existing bundle
        const updatedBundles = [...prevBundles];
        updatedBundles[existingBundleIndex] = newBundle;
        return updatedBundles;
      } else {
        // Add new bundle
        return [...prevBundles, newBundle];
      }
    });
  };

  const joinQna = () => {
    history.push({
      pathname: "/superstar-admin/qna/QnaMsgBox",
      state: {
        enrolldata: slot,
        slug: event_id,
        event: event,
        from: "admin",
      },
    });
  };

  const startTime = moment(availabilityStartTime).format("LL HH:mm:ss");
  const endTime = moment(availabilityEndTime).format("LL HH:mm:ss");

  const countDownDate = new Date(startTime).getTime();
  const [timeStart, setTimeStart] = useState(false);

  const now = new Date().getTime();
  const countdownLabel = now < countDownDate ? "Starts in" : "Ends in";
  const countdownTime = now < countDownDate ? startTime : endTime;

  const [showModal, setShowModal] = useState(false);

  const [selectedBundle, setSelectedBundle] = useState(null);
  const [mode, setMode] = useState("add");

  const handleShowModal = (bundle = null) => {
    setSelectedBundle(bundle);
    setMode(bundle ? "edit" : "add");
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);
  const handleDeleteBundle = (bundleId) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this bundle!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios
          .delete(`/api/admin/qna/${event_id}/bundle/${bundleId}`)
          .then((res) => {
            if (res.data.status === 200) {
              swal({
                title: "Success",
                text: res.data.message,
                icon: "success",
                timer: 1000,
                buttons: false,
              });
              setBundles(bundles.filter((bundle) => bundle.id !== bundleId));
            } else {
              swal("Error", res.data.message, "error");
            }
          });
      }
    });
  };
  return (
    <>
      <div className="AS">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-7  mb-3">
              <div className="card card-bg p-2">
                <img
                  src={imageCdnUrl + event.banner}
                  alt=""
                  className="img-fluid w-100 MeetUpPosition"
                />
                <Countdown
                  date={countdownTime}
                  renderer={ContdownTimerRender}
                />
              </div>
            </div>
          </div>

          <div className="row mb-3 ">
            <div className="col-md-12">
              <div className=" shadow">
                <div className="registration-head  card-bg ">
                  <h5 className="text-warning fw-bold p-2">Registration</h5>
                </div>

                <div className="row registration-body  card-bg m-0 pt-3">
                  <div className="col-md-4 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Registration Start:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {moment(event.registration_start_date).format("LL")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag1} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Registration End:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {moment(event.registration_end_date).format("LL")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag2} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">
                          Maximum Question Time:
                        </span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.max_time} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag3} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">
                          Minimum Question Time:
                        </span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.min_time} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag4} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Total Minutes:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.total_minutes} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag4} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Available Minutes:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.available_minutes} Minute(s)
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag4} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Registration Fee:</span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          ${event.fee}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-1">
            <div className="col-md-12">
              <div className="card card-bg shadow">
                <div className="card-body">
                  <h5 className="text-light pb-3">{event.title}</h5>

                  <h5 className="text-warning">Instruction</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={event.instruction} />
                  </p>

                  <h5 className="text-warning">Description</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={event.description} />
                  </p>

                  <div className="col-md-4 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                    <h5 className="text-warning pt-2 ">Star Availability</h5>
                    <p className="text-light fw-bold pt-2">
                      {moment(event.star_availability_start_date).format("LL")}{" "}
                      - {moment(event.star_availability_end_date).format("LL")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-1">
            <div className="col-md-12">
              <div className="card card-bg shadow">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="text-warning">Bundles</h5>
                    <button
                      className="btn btnStatus fw-bold px-4 hover-btn"
                      onClick={() => handleShowModal(null)}
                    >
                      Add Bundle <i className="fa fa-plus"></i>
                    </button>
                  </div>
                  <div className="NotifyOver w-100 mb-5">
                    <table className="w-100 my-3 NotifyTabletd">
                      <thead style={{ borderBottom: "2px solid gold" }}>
                        <tr className="NotifyTable mx-3">
                          <td className="Notifytdx lNTS"> SL. </td>
                          <td className="Notifytdx"> Discount Percentage </td>
                          <td className="Notifytdx"> Minutes required </td>
                          <td className="Notifytdx"> Action </td>
                        </tr>
                      </thead>
                      <tbody>
                        {bundles.length > 0 ? (
                          bundles.map((bundle, index) => (
                            <tr className="NotifyTable mx-3" key={bundle.id}>
                              <td className="Notifytdx">{index + 1}</td>
                              <td className="Notifytdx">
                                {Number(bundle.percentage).toFixed(2) + "%"}
                              </td>
                              <td className="Notifytdx">{bundle.minutes}</td>
                              <td className="Notifytdx ">
                                <i
                                  className="fa fa-pen mx-1 cursor-pointer p-2 bg-warning rounded-circle"
                                  title="Edit"
                                  onClick={() => handleShowModal(bundle)}
                                ></i>
                                <i
                                  className="fa fa-trash mx-1 cursor-pointer p-2 bg-danger rounded-circle"
                                  title="Delete"
                                  onClick={() => handleDeleteBundle(bundle.id)}
                                ></i>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              className="Notifytdx"
                              colSpan="4"
                              style={{ textAlign: "center", color: "white" }}
                            >
                              No bundles added yet
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card card-bg mt-3">
            <div className="row">
              <div className="col-md-4 d-flex justify-content-center align-items-center">
                <img src={clock} className="img-fluid p-3" alt="" />
              </div>
              <div className="col-md-4 d-flex align-items-center">
                <div>
                  <h2 className="text-warning">Event Details submitted</h2>
                  <p className="text-light">
                    &nbsp;
                    {event.star_approval === 1 && Number(event.status) === 0 ? (
                      <span className="fw-bold">Waiting for Manager Admin</span>
                    ) : event.star_approval === 0 &&
                      Number(event.status) === 0 ? (
                      <span className="fw-bold">Waiting for SuperStar</span>
                    ) : Number(event.status) === 1 ? (
                      "Approved By Superstar and Manager Admin"
                    ) : null}
                    &nbsp;
                  </p>

                  {event.star_approval < 1 ? (
                    <Link to={`/superstar-admin/qna/edit/${event.id}`}>
                      <button className="btn btnStatus fw-bold px-4  ">
                        Edit
                      </button>
                    </Link>
                  ) : null}
                </div>
              </div>
              <div
                className="col-md-4"
                style={{ borderLeft: "1px dashed yellow" }}
              >
                <h5 className="text-light text-center my-3">Status</h5>
                <div className="d-flex justify-content-center align-items-center ">
                  <div style={{ width: 150, height: 150 }}>
                    {Number(event.status) > 1 ? (
                      <CircularProgressbarWithChildren
                        value={100}
                        styles={buildStyles({ pathColor: `gold` })}
                      >
                        {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                        <div style={{ fontSize: 12, marginTop: -5 }}>
                          <strong className="text-light">100% complete</strong>
                        </div>
                      </CircularProgressbarWithChildren>
                    ) : event.star_approval === 1 ? (
                      <CircularProgressbarWithChildren
                        value={50}
                        styles={buildStyles({ pathColor: `gold` })}
                      >
                        {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                        <div style={{ fontSize: 12, marginTop: -5 }}>
                          <strong className="text-light">50% complete</strong>
                        </div>
                      </CircularProgressbarWithChildren>
                    ) : (
                      <CircularProgressbarWithChildren
                        value={0}
                        styles={buildStyles({ pathColor: `gold` })}
                      >
                        {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                        <div style={{ fontSize: 12, marginTop: -5 }}>
                          <strong className="text-light">0% complete</strong>
                        </div>
                      </CircularProgressbarWithChildren>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {Number(event.status) >= 1 ? (
        <div className="row my-3">
          <div className="col-md-12">
            <div className="card card-bg solt-card">
              <div className="card-body">
                <h3 className="text-warning">
                  <img src={vector} alt="clock" className="mx-2"></img>
                  Registered Users ({slot.length})
                </h3>
                <div className="row my-3">
                  {slot.map((user, index) => (
                    <div className="col-md-2 col-sm-3 ">
                      <p className="sold-small-card fw-bold text-ellipsis">
                        <img
                          src={imageCdnUrl + user.user?.image}
                          className="img-fluid mx-2 p-1"
                          alt=""
                          style={{ height: "50px", width: "50px" }}
                        />
                        {user.user?.first_name} {user.user?.last_name}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {Number(event.status) === 2 &&
        (Date.now() >= new Date(startTime).getTime() &&
        Date.now() <= new Date(endTime).getTime() ? (
          <center className="mt-5 ">
            <button
              onClick={joinQna}
              className="btn btnJoinNow  fw-bold px-5 mx-2"
            >
              Join Now
            </button>
          </center>
        ) : null)}
      <AddBundleModal
        show={showModal}
        handleClose={handleCloseModal}
        qnaId={event?.id}
        onBundlesChange={handleBundlesUpdate}
        bundle={selectedBundle}
        mode={mode}
      />
    </>
  );
};

export default QnADetails;
